import React, { ReactElement, useEffect, useRef, useState, MutableRefObject } from 'react';
import { IComponentAssociateLocatorFields } from 'types/contentful';
import RichText from 'components/UI/Richtext';
import StaticMap from 'components/UI/StaticMap';

type Map = { lat: number; lng: number };

export default function AssociatesMap({
  heading,
  description,
  locationsFragments,
}: IComponentAssociateLocatorFields): ReactElement {
  const [locationMaps, setLocationMaps] = useState<Map[]>();
  const mapContainer = useRef() as MutableRefObject<HTMLDivElement>;

  useEffect(() => {
    if (locationsFragments) {
      const newLocationMaps = locationsFragments.map((x) => {
        return { lat: x.fields.map.lat, lng: x.fields.map.lon };
      });
      setLocationMaps(newLocationMaps);
    }
  }, [locationsFragments]);

  return (
    <div className="flex flex-col lg:flex-row justify-center ecp-my mx-auto gap-8 lg:gap-6 py-10 md:py-20 px-site-component overflow-hidden">
      <div className="w-full lg:w-1/2">
        <div className="flex items-center mb-6 lg:mb-8 justify-start">
          <h2 className="bordered-heading bh-location-heading-item font-heading text-new-34 lg:text-4xl lg:leading-new-43 text-primary-actual">
            {heading}
          </h2>
        </div>
        {description && (
          <RichText
            document={description}
            classNames="leading-relaxed text-lg  font-light text-primary-actual center_richtext_content mb-6 lg:mb-8"
          />
        )}
        <div className="flex flex-row flex-wrap justify-start -m-1">
          {locationsFragments?.map((x, index) => (
            <button key={index} className={`rounded-full bg-highlight py-2 px-3 m-1`}>
              <a
                href={x.fields.locations.fields.slug}
                className="capitalize button-text text-base whitespace-no-wrap"
              >
                {x.fields.name}
              </a>
            </button>
          ))}
        </div>
      </div>
      <div
        className="w-full lg:w-1/2 h-associate-locator-map pb-2 lg:pb-0 relative text-primary-actual"
        ref={mapContainer}
      >
        <StaticMap
          staticLocations={locationMaps}
          defaultCenter={{ lat: 37.7749, lng: -122.4194 }} // Default center on San Francisco
          zoom={10}
          iconDetails={{
            hideEyeOnPin: false,
            markerIcon: 'Clarkson-style Eye',
            classNames: 'bg-grey',
            focused: false,
          }}
        />
      </div>
    </div>
  );
}
